import React, { memo, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import TransactionForm from './TransactionForm';
import NewCategoryForm from './NewCategoryForm';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import useStyles from './styles/navbar.styles';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import { AuthContext } from '../context/auth.context';
import { TipsContext, DispatchTipsContext } from '../context/tips.context';
import ProfilePopover from './ProfilePopover';
import BudgetForm from './BudgetForm';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import MobileSidebar from './MobileSidebar';
import Tip from './Tip';
import Carousel from './Carousel';
import Fab from '@material-ui/core/Fab';
import Zoom from '@material-ui/core/Zoom';

function Navbar() {
	const classes = useStyles();
	const currentUser = useContext(AuthContext);
	const showTips = useContext(TipsContext);
	const dispatchTips = useContext(DispatchTipsContext);
	const location = useLocation().pathname;
	const [ anchorProfile, setAnchorProfile ] = useState(null);
	const [ drawerOpen, setDrawerOpen ] = useState(false);
	const [ dialogOpen, setDialogOpen ] = useState(false);
	const [ tipOpenUp600, setTipOpenUp600 ] = useState(false);
	const [ tipOpenDown600, setTipOpenDown600 ] = useState(false);
	const [ carouselOpen, setCarouselOpen ] = useState(false);
	const up600 = useMediaQuery('(min-width:600px)');

	useEffect(
		() => {
			showTips.carousel && setCarouselOpen(true);
			if (!showTips.carousel && showTips.transactions && location === '/') {
				!up600 ? setTipOpenDown600(true) : setTipOpenUp600(true);
			}
		},
		[ location, showTips, up600 ]
	);

	const closeCarousel = () => {
		setCarouselOpen(false);
		dispatchTips({ type: 'SET_SECTION_TIPS', section: 'carousel', open: false });
	};

	const closeTip = () => {
		setTipOpenUp600(false);
		setTipOpenDown600(false);
		if (location === '/') {
			dispatchTips({ type: 'SET_SECTION_TIPS', section: 'transactions', open: false });
		}
	};

	return (
		<React.Fragment>
			<Zoom
				in={
					!up600 &&
					(location === '/' || location === '/categories' || location === '/budgets')
				}>
				<div className={classes.fab}>
					<Tip
						title="Tap here to add a new transaction"
						open={tipOpenDown600}
						handleClose={closeTip}
						placement="top"
						buttonTop
						enableClickAway>
						<Fab
							onClick={() => {
								closeTip();
								setDialogOpen(true);
							}}
							color="primary"
							aria-label="add">
							<AddIcon />
						</Fab>
					</Tip>
				</div>
			</Zoom>
			<Carousel open={carouselOpen} handleClose={closeCarousel} />
			{location === '/' && (
				<TransactionForm dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} />
			)}
			{location === '/categories' && (
				<NewCategoryForm dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} />
			)}
			{location === '/budgets' && (
				<BudgetForm dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} />
			)}
			<ProfilePopover anchorEl={anchorProfile} setAnchorEl={setAnchorProfile} />
			<MobileSidebar drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
			{up600 && (
				<AppBar position="sticky" className={classes.root}>
					<Toolbar className={classes.toolbar}>
						{location !== '/jars' &&
						location !== '/reports' && (
							<div className={classes.addButtonContainer}>
								<Tip
									title="Tap here to add a new transaction"
									open={tipOpenUp600}
									handleClose={closeTip}
									enableClickAway>
									<Button
										variant="contained"
										color="primary"
										onClick={() => {
											closeTip();
											setDialogOpen(true);
										}}>
										{(location === '/' && 'Add Transaction') ||
											(location === '/categories' && 'Create Category') ||
											(location === '/budgets' && 'Create Budget')}
									</Button>
								</Tip>
							</div>
						)}
						<Tooltip title="Sign out" arrow>
							<IconButton
								onClick={e => setAnchorProfile(e.currentTarget)}
								className={classes.avatarButton}
								aria-label="sign out">
								<Avatar
									alt={currentUser.displayName}
									src={currentUser.photoURL}
									className={classes.avatar}
								/>
							</IconButton>
						</Tooltip>
					</Toolbar>
				</AppBar>
			)}
		</React.Fragment>
	);
}

export default memo(Navbar);
